import React, { useEffect, useState } from "react";
import "./manageUsers.css";
import InviteNewUser from "../../adminComponents/InviteUser/InviteUser";
import ListAllUsers from "../../adminComponents/ListAllUsers/ListAllUsers";

const ManageUsers = () => {
  const [inviteOpen, setInviteOpen] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="mu-page">
      <div className="mu-container bdr-grad-container-med bdr-border-std bdr-shadow-depth bdr-dark-placeholder">
        <div className="mu-header">
          <h1 className="mu-title">Manage Users</h1>
          <button
            type="button"
            className="mu-invite-btn"
            onClick={() => setInviteOpen(true)}
          >
            + Invite New User
          </button>
        </div>
        <ListAllUsers />
      </div>
      {inviteOpen && <InviteNewUser onClose={() => setInviteOpen(false)} />}
    </div>
  );
};

export default ManageUsers;
